import { IArcgisMap, TDimension } from "@mctypes/global.types";
import { Group, Select, ThemeIcon } from "@mantine/core";
import { IconCheck, IconX } from "@tabler/icons-react";
import * as R from "ramda";
import React, { useEffect, useState } from "react";
import { apiSlice } from "../../../../apiSlice";
import { setShowSuccessMessageThunk } from "../../../../global/globalSlice";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { DimensionEnums, ToastMessagesEnums } from "../../../../mc-shared/sharedConstants";
import { setProjectArcgisInRedux } from "../../../actions";
import { doUpdateDefaultMap } from "../../gis/GisAPI";

const UpdateDefaultArcgisMap: React.FC<{
  projectId: string;
  defaultMapId: string;
  arcgisMaps: IArcgisMap[];
  dimension: TDimension;
}> = ({ projectId, defaultMapId, arcgisMaps, dimension }) => {
  const [map, setMap] = useState<IArcgisMap>(null);

  const dispatch = useAppDispatch();

  const project = useAppSelector((state) => state.adminReducer.project);

  const updateMap = async (_map: IArcgisMap) => {
    const defaultMap = await doUpdateDefaultMap(projectId, _map?.id, dimension);
    let arcgis = R.clone(project.arcgis);
    if (dimension === DimensionEnums.TWODIMENSION) {
      arcgis.default2dMap = defaultMap;
    }
    if (dimension === DimensionEnums.THEREEDIMENSION) {
      arcgis.default3dMap = defaultMap;
    }
    dispatch(setProjectArcgisInRedux(arcgis));
    dispatch(setShowSuccessMessageThunk(ToastMessagesEnums.UPDATED));
    dispatch(apiSlice.util.invalidateTags(["Project"]));
    setMap(_map);
    dispatch(setShowSuccessMessageThunk("Standard kart oppdatert"));
  };

  useEffect(() => {
    const _map = arcgisMaps.find((mp) => mp.id === defaultMapId);
    setMap(_map);
  }, [arcgisMaps, defaultMapId]);

  return (
    <Group gap="xs">
      <Select
        placeholder="Velg"
        value={map?.id ?? null}
        data={(arcgisMaps || []).map((arcgisMap) => ({ value: arcgisMap.id, label: arcgisMap.title }))}
        onChange={(mapId) => {
          const selectedMap = arcgisMaps.find((arcgisMap) => arcgisMap.id === mapId);
          if (selectedMap != null) {
            updateMap(selectedMap);
          }
        }}
      />
      <ThemeIcon color={map != null ? "green" : "red"} variant="light" size="sm" radius="xl">
        {map != null ? <IconCheck size={14} /> : <IconX size={14} />}
      </ThemeIcon>
    </Group>
  );
};

export default UpdateDefaultArcgisMap;
